import SearchModalContents from './SearchModalContents';

export default SearchModalContents;
